import { TutorialInfoProps } from "./types";
import { cn } from "@/lib/utils";

export function TutorialInfo({ children }: TutorialInfoProps) {
  return (
    <div
      className={cn(
        "relative rounded-2xl border border-cede-border-container/50 bg-cede-bg-component/40 px-5 py-5 text-left",
      )}
    >
      <div className="[&_p]:text-cede-text-secondary [&_p]:leading-relaxed [&_p]:text-sm">{children}</div>
    </div>
  );
}
